// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationGrid-GridCollapse-k3Osp {
	position: relative;
}

.PopularLocationGrid-containerTitle-r_4CL {
	color: var(--primary-foreground);
	line-height: normal;
	margin: 0 0 45px;
	padding: 0px 15px;
	font-weight: bold;
	font-size: 32px;
	-webkit-transition: all .4s ease-out;
	transition: all .4s ease-out;
}

.PopularLocationGrid-noLeftPadding-Z0XsU {
	padding: 0;
}

.PopularLocationGrid-popularLocationSwiperContainer-Nhk3C {
	position: relative;
}

@media screen and (max-width: 767px) {
	.PopularLocationGrid-marginLeft-yFQcC {
		margin: 0 0 24px 34px;
	}

	.PopularLocationGrid-containerTitle-r_4CL {
		margin: 0 0 40px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationGrid/PopularLocationGrid.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,oCAA4B;CAA5B,4BAA4B;AAC7B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".GridCollapse {\n\tposition: relative;\n}\n\n.containerTitle {\n\tcolor: var(--primary-foreground);\n\tline-height: normal;\n\tmargin: 0 0 45px;\n\tpadding: 0px 15px;\n\tfont-weight: bold;\n\tfont-size: 32px;\n\ttransition: all .4s ease-out;\n}\n\n.noLeftPadding {\n\tpadding: 0;\n}\n\n.popularLocationSwiperContainer {\n\tposition: relative;\n}\n\n@media screen and (max-width: 767px) {\n\t.marginLeft {\n\t\tmargin: 0 0 24px 34px;\n\t}\n\n\t.containerTitle {\n\t\tmargin: 0 0 40px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GridCollapse": `PopularLocationGrid-GridCollapse-k3Osp`,
	"containerTitle": `PopularLocationGrid-containerTitle-r_4CL`,
	"noLeftPadding": `PopularLocationGrid-noLeftPadding-Z0XsU`,
	"popularLocationSwiperContainer": `PopularLocationGrid-popularLocationSwiperContainer-Nhk3C`,
	"marginLeft": `PopularLocationGrid-marginLeft-yFQcC`
};
module.exports = ___CSS_LOADER_EXPORT___;
